'use-client';
import CollapsibleText from '../../CollapsibleText';

export default CollapsibleText;
